import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import TMPayoutTable from "components/tenant-market/payout/tm-payout-table"
// Data
import api_match from "data/interface/api"
import propertyService from 'data/property.ts'
import importService from "data/import"
import payoutService from "data/payout"
import { alphanum } from "components/table/lib/sort"
//Styles
import { TMPayout_s } from "components/tenant-market/payout/tm-payout-styles"
import { AddIcon } from "images/icons/tools"

const TMPayout: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const tableId = "tm-payout-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const property = _.find(data.value, {propertyid: data.current});
        setProperty(property)
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const payoutSubscription = payoutService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      propertySubscription.unsubscribe()
      payoutSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    propertyService.fetchProperty(propertyId)
    payoutService.fetchPayout(propertyId)

  }, [propertyId])

  const Add = () => {
    return (
      <a onClick={() => payoutService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <TMPayout_s>
      <Toolbar>
        <Add />
        <ImportIcon />
        <ExportIcon template="payout" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && !showImport &&
      <TMPayoutTable
        tableId={tableId}
        data={data}
        defaults={{...property['defaultsnameditem']}} /> }
    </TMPayout_s>
  )
}

export default TMPayout
